<template>
<div class="general-back"> 
<v-layout py-2 px-1 row wrap fill-height justify-center align-center class="general-map">
<!-- CONTENDOR DE LOS PROYECTOS -->
  <v-flex xs11 sm5 md5 lg5 class="general-proyectos mx-2">
    <div class="cont-proyectos">
      <v-card>
         <v-tabs v-model="tab" height="25px" 
            grow dark
            slider-color="transparent"
            centered 
            color="transparent"
        >
          <v-tab class="tab-button" :class="{'tab-inactive':!tabactive, 'tab-ejec':tabactive}" @click="tabactive = true , tabnum = 0" href="#tab-1">En Ejecución</v-tab>
          <v-tab class="tab-button" :class="{'tab-inactive':tabactive , 'tab-fin':!tabactive}" @click="tabactive = false , tabnum = 1" href="#tab-2">Finalizados</v-tab>
        </v-tabs>
        <h2 class="titulo-proyectos--estado" :class="{'bg-ejecucion':tabactive}">Proyectos {{tabname[tabnum]}}</h2>
        <v-tabs-items v-model="tab" class="general-taps-container">
          <v-tab-item class="tab-container" :class="{'tab-scroll':maxtab}" :value="'tab-1'">
            <v-card flat class="px-2 py-2">
              <div class="cont-item-proyectos">
                <div v-for="(item, index) in info.items" :key="'item'+index" class="item-proyectos"
                :class="{'item-active':itactive[index]}" 
                @click="actionProyect(index)" v-show="item.estado == 'true'">
                  <img :src="'https://static.adaptacioncc.com/images/'+item.img+'.png'" alt="">
                </div>
              </div>
            </v-card>
          </v-tab-item>
          <v-tab-item class="tab-container" :class="{'tab-scroll':maxtab}" :value="'tab-2'">
            <v-card flat class="px-2 py-2">
              <div class="cont-item-proyectos">
                <div v-for="(item, index) in info.items" :key="'item'+index" class="item-proyectos"
                :class="{'item-active':itactive[index]}" 
                @click="actionProyect(index)" v-show="item.estado == 'false'">
                  <img :src="'https://static.adaptacioncc.com/images/'+item.img+'.png'" alt="">
                </div>
              </div>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </div>
      
    <!-- CONTENEDOR DE INFORMACIÓN -->
    <div class="cont-decription animated fadeIn" v-show="mostrarinfo">
      <button @click="cerrarinfo()" class="hvr hvr-scale iconcerrar"><v-icon dark class="icon">close</v-icon></button>
      <img :src="selected_image" alt="">
      <div class="text-desc">
        <h2>{{info.items[openitem].name}}</h2>
        <a class="linkpdf" :href="'https://static.adaptacioncc.com/documentos-pdf/'+info.items[openitem].urlpdf" target="_blanck">
          <div class="btn-vermas"> <span class="text-button">Ver más</span></div>
        </a>
      </div>
    </div>
  </v-flex>
<!-- CONTENDOR DEL MAPA -->
  <v-flex xs11 sm6 md5 lg5 class="mapa" >
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 907.9 936.3" xml:space="preserve">
      <g>
        <path class="st0" d="M145.5 551.2c6.4 6 13.7 12.7 24.8 14.6 3.8.7 8.2 3 11.4 5.8 2.7 2.5 6.2 5.2 10.7 6.7-.2.5-.4 1-.5 1.5-.4 2.1.5 4.4 2.3 5.7l33.3 24.9c1.1.8 2.3 1.2 3.6 1.2 1.1 0 2.3-.4 3.2-1 2.1-1.3 3.1-3.9 2.6-6.3-1-4 .5-6.4 5.8-9.8 8.3-5.2 14.8-12.3 19.5-21.1.4 1.1 1 2 1.8 2.7.5.4 1 .7 1.4 1l-8.5 7.1c-1.4 1.2-2.3 3.1-2 5 .1 1.9 1.3 3.7 3 4.6l7.3 4.3h-.1c-1.1-.2-2.1-.4-3.3-.4-10 0-26.6 9.8-29.3 19.4-1.9 6.8-2.6 13.8-3.3 20.6-.1 1.3-.2 2.7-.5 4-.5 4.6 3.9 8.3 6.8 9.5 1.3.6 3 .8 4.6.8 5.6 0 14.2-3.1 18.1-7.7 1.7-2 1.9-4.9.5-7.1-.6-1-1.3-2-2-3-.1-.2-.4-.5-.5-.7h1.1c6 0 9-5.1 10.1-6.8 1.2-1.9 3.5-3.6 6-5.5 1.1-.7 2-1.5 3.1-2.4.5-.5 1.3-1 2.5-1.5.7-.4 1.5-.8 2.4-1.4 1.9-1.1 3-3.1 2.9-5.4-.1-2.3-1.3-4.2-3.2-5.1-1.7-.8-3.2-1.7-4.6-2.6-1-.6-1.9-1.1-2.9-1.7.7-.1 1.4-.4 2.1-.7 1.8-1.1 3-3 3.1-5.1 0-.6.2-1.2.5-1.8-.1 1.2.2 2.5.8 3.6.8 1.3 2.1 2.4 3.7 2.7l1.5.4c.5.1 1 .1 1.3.1 2.5 0 4.8-1.5 5.6-3.9.4.5.8.8 1.3 1.2-1.8 2.9-2.5 6.1-3 9.2-.1.5-.1 1.1-.2 1.5-.4 2.7-.7 5.5-1.7 7.3-5 9-4.5 18.3-4 26.6.1 1.4.1 2.9.2 4.2 0 .8.2 1.5.6 2.3-1.4.6-2.6 1.4-3.6 2.4-1.8 1.8-2.7 4.3-2.7 6.8.1 2.9-1.1 3.9-4.5 6.9-.8.7-1.7 1.3-2.5 2.1l-2.9 2.6c-4.6 4.3-9.5 8.7-14.5 12.7-.8.6-2.4 1.2-3.9 1.7-1.1.4-2 .7-3.2 1.2L243 687c-2.6 1.1-4 3.8-3.6 6.7l.4 2c.2 1.1.6 1.9 1.3 2.6-.2.1-.6.1-.8.2-1.5.4-2.9 1.4-3.6 2.7-.7 1.3-1 3-.6 4.5.7 2.5 1.4 4.8 2.1 6.9 1.4 4.2 2.6 7.9 2.6 11.1.1 9.3 1 21.8 6.7 35.7.2.5.5 1 .8 1.3-4.9 2.9-9 6.2-12.5 9-3.2 2.6-5.7 4.5-7.4 4.5-1 0-2.3-.5-3.8-1.4-1.4-.8-3.2-1.3-5.2-1.3-3.6 0-7.5 1.4-10 3.5-3.6 3-6.1 8.3-6.1 13 0 3.9 1.9 7.3 3.5 9.9.4.6.7 1.2 1 1.8.4.7.9 1.5 1.4 2.3-4.9 4.4-8.4 7.9-9.8 10-9.3 13.3-46.7 10-47.2 49.9-.4 40 10.7 66.6-3.2 68.2-3.7.4-5.3 2.8-5.7 5.9H908V0H410.7c-23.1 11.6-20.7 46-12.5 77.7-.9.4-1.7 1.1-2.3 2-1.1 1.4-2.1 3-3.2 4.5-2.3 3.2-4.4 6.2-6.8 9-4.8 5.7-10.7 8.6-18 8.6h-.5c-1.3 0-2.7-.1-4.2-.1-1.9-.1-3.8-.1-5.8-.1-5.1 0-8.9.6-12.4 1.8-6.8 2.4-13.1 6-19.2 9.3-2.4 1.3-4.8 2.6-7.1 3.9-2-1.5-4.3-2.4-6.8-2.4-4.8 0-8.1 2.9-9.3 4.2-6.4 6.5-13.5 11-21.3 13.6-1.9.6-3.8 1.2-5.8 1.8-3.5 1.1-7 2-10.5 3.5-6.2 2.4-9.6 5.5-10.5 9.3-1.1 4.6-3.2 14.5 7.6 19.6 1.2.6 2.7 3 3.2 6.1.5 2.9 0 5-.6 5.6-1.2 1.2-4.8 4.8-4.2 9.6.6 4.8 4.8 7.4 6.8 8.6 1 .6 1.8 1.1 1.5 4.8-.1 2.4.1 4.5.4 6.2.1.5.1 1 .1 1.3.1 1.8 1.2 3.5 2.7 4.5.7.5 1.5.8 2.5.8-.5.7-.8 1.5-1.2 2.1-.4.7-.7 1.3-1.1 2-.2.4-.5.7-.6 1.1-.7-.5-1.5-1.1-2.4-1.5-1-.5-1.9-.7-2.9-.7-.8 0-1.5.1-2.4.5-1.7.7-3 2.1-3.5 3.9-.5 1.8-1 3.6-1.3 5.4-1.7 7-3.2 13.8-7.9 19.2-1 1.1-1.9 2.1-2.7 3.2-7.7 9-15.1 17.6-25.7 22.3-4.2 1.8-8 6-9.2 9.9-1.8 5.8-5.7 9.9-11.1 14.1-1.9 1.4-2.6 3.9-2 6.3.6 2 1.1 4 1.7 6.1 1.5 5.4 3 10.4 4.2 15.5.1.6.1 1.4-.1 1.9-4.4 11.9-8.5 22.3-12.3 31.7-1.8 4.3-3.5 7.6-5.4 10.5-1.4 2.1-2.6 2.5-4.2 2.5-.6 0-1.2-.1-1.9-.2-1.8-.4-3.7-.5-5.8-.5-1.5 0-3.1.1-4.6.1-1.3.1-2.6.1-3.8.1-10.8.1-16.6 7.4-21.2 13.3l-.6.7c-2.3 2.9-2.6 8-.7 11.3.8 1.5 1.8 3.1 2.6 4.6 3.7 6.7 7.5 13.5 12.1 19.8l.1.2c4.8 6.4 6.3 9 4.4 13.2s-4 8.3-6 12.5c-1.5 3.1-3.1 6.3-4.5 9.4-1 2-2.7 5.7-.8 9.2 1.5 3 3.5 5.8 6.2 7.3-.7 1.4-.8 3.1-.4 4.6.1.4.2.6.4 1 .2.7.5 1.3.7 1.9.6 1.3 1.2 2.7 1.8 4 4.2 9.3 7.9 17.3 3.8 26.2-1.3 2.9-.1 5.5.5 6.7l.1.2c1.8 4.3.7 8.3-3.3 12-3.6 3.2-8 5.8-12.6 8.7-2.3 1.3-4.5 2.7-6.8 4.2-1.5 1-2.5 2.6-2.7 4.5-.1 1.8.6 3.7 1.9 4.9.9.4 1.6 1 2.2 1.6z"/>
        <g>
          <path class="st0" d="M118.7 169.6c-.2-1.5-1-3-2.3-3.9-1.1-.8-2.4-1.3-3.7-1.3-.4 0-.6 0-1 .1-1.5.2-3.1.5-4.6.7-3.5.5-6.9 1-10.5 1.9.8-.8 1.5-1.7 2.1-2.5 1-1.3 1.2-3 .8-4.6-2.5-11.2-12-14.4-16.7-16.1l-.7-.2c-1.8-.6-3.8-1.3-6.2-1.3-2.5 0-6.1.8-8.9 4.9-2.4 3.5-3.3 6.5-3.5 9.4l-.8-.8c-1.3-1.2-3.9-3.6-4.6-4.8.6-8.2-3.5-13.9-6.7-18.5-1.2-1.7-2.3-3.1-3.1-4.6-1.8-3.5-6.7-5.7-10.1-5.7-1.3 0-2.4.2-3.5.8-4.6 2.5-9.4 5.6-14.9 9.9-3.1 2.4-5.5 8.8-2.6 12.9 2.5 3.6 7.3 4.5 9.3 4.8.4 0 .8.1 1.2.1-1.7.6-3.2 1-4.9 1.4-4.4 1.1-8.6 2.3-10.6 6.1-2.1 3.8-1 8 .5 12.4 2.4 7.1 8.6 11.2 16.9 11.2.7 0 1.4 0 2.1-.1 1.5-.1 3-.4 4.2-.8-3.8 2.5-6.9 5.7-9.6 8.6-.7.7-1.4 1.5-2.1 2.3-2.5 2.5-4.2 7.5-2.7 11.6 3.2 8.8 17.7 14.3 26.7 14.3 2.5 0 4.8-.4 6.7-1.2 4.2-1.7 8.5-3 13.3-4.5 5.6-1.7 11.8-9.6 13.9-14.5 1.5-3.5 1.8-6.5.6-9.2-1.8-3.8-4.3-7.1-6.9-10.5-.6-.7-1.2-1.5-1.8-2.3.2-1.5.2-3 0-4.4 2.4 1 5.1 1.4 8 1.4 2.5 0 4.9-.4 7-1.1-1.5 1.5-2.9 3.2-3.6 5.1-4.9 11.9 1.8 16.4 10.4 20.6 2.6 1.3 5.4 1.9 8.2 1.9 8.6 0 16.4-6.1 19.2-14.8 2.3-7.1-1.8-11.4-3.8-13.5 0-.5-.5-.9-.7-1.2zm-78.8 9.3c1-.7 1.9-1.7 2.6-2.7l1.1 1.4c-1.4.4-2.5.8-3.7 1.3zM183.9 185.5c-1-4-4.8-5.5-7-6.3-.4-.1-.7-.2-.8-.4-.8-.5-1.8-.7-2.7-.7-.4 0-.7 0-1.1.1-.6.1-1.1.1-1.7.2-1.7.1-3.7.4-5.6 1.8-5.6 4-11.6 8.5-17.3 13.3-1.1.8-2.3 2.5-2.5 5.4-.1 1.9.4 5.8 2.6 8.2 2.4 2.6 6.3 4 10.8 4 4.6 0 11.2-1.5 14.8-6.1.8-1.1 1.8-2.3 2.9-3.3 1.4-1.7 3-3.5 4.3-5.4 2.2-3.2 4.2-6.9 3.3-10.8zM111.9 219.6c-1.2-.7-2.3-1.4-3.3-2.1-2.3-1.5-4.4-3-6.9-3.8-.8-.2-1.7-.4-2.5-.4-3.2 0-6.7 1.9-9.2 5.1-2.5 3.2-3.5 6.9-2.6 10.1 1.1 4.2 6.5 9.4 11.2 9.4.7 0 1.4-.1 2-.4 3.3-1.1 5.7-3.2 8.3-5.4 1.1-.8 2.1-1.8 3.3-2.7 1.5-1.2 2.4-3.1 2.3-5s-1.1-3.7-2.6-4.8zM89 126.3c.7.8 1.3 1.8 2 2.7 1 1.4 2.5 2.4 4.3 2.6h.7c1.4 0 2.9-.6 4-1.5l7.7-7c1.3-1.2 2-2.9 1.9-4.5 0-1.8-.8-3.3-2.1-4.4-.6-.5-1.2-1.1-1.8-1.5-1.9-1.8-4.4-4-7.6-5.1-.6-.2-1.3-.4-2-.4-4.2 0-7.9 3.8-8.5 4.5-1.9 2-2.7 4.2-2.5 6.3.2 3.4 2 5.9 3.9 8.3z"/>
        </g>
      </g>
      <g class="item-a" id="carchi">
        <path class="st1" d="M471.6 94.3c4.4 5.5 5.6 5.6 12.9 1.1 1.7-1.1 3.7-1.5 6.7-2.6 1 5 1.3 9.4 2.7 13.2 1.1 2.9 3.5 5.2 5.4 7.7 1.7 2.4 3.2 4.8 5.1 6.9 2 2.1 4.2 5.4 6.5 5.8 8.7 1.4 15.6 6.2 22.3 11.4 6.5 5.1 19.2 6 26.4 2.1 2.9-1.4 6.7-1.2 10-1.2.7 0 1.9 1.9 2 3 .5 8.6.4 8.6 2.3 12.4-1.1 4.3-1.4 7.1-2.5 9.8-1 2.5-2.3 5-3.9 7.1-1.8 2.4-4.2 4.3-6.1 6.5-.7.8-1 2.1-1.7 3.1-5.5 6.9-5.6 6.9-6 14.6-7.1-4.5-14.1-8.9-21.1-13.2-1.8-1.1-4-2-6-1.8-5.6.5-7.6-3.1-7.7-7.4-.1-10.6-6.8-17.4-13-24.3-4.3-4.8-9.4-8.8-14.6-12.5-2.5-1.8-6.1-2.5-9.3-2.9-15.2-1.8-17.9-11.8-17.1-24.3 0-.2 0-.4.1-.6 2.3-4.3 4.4-9 6.6-13.9z"/>
        <g class="item-text">
          <path class="st2" d="M531.2 131.3h84.3v31.2h-84.3z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 537.9 156.26)" class="st3 st4 st5">
              Carchi
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="sucumbios">
        <path class="st1" d="M746.4 196.7c5.4 1.4 9.3 1.9 10.6-3.6 0-.1 3.2-.1 4.3.7 4.2 3.3 8.5 6.1 14.3 4.9 1.1-.2 3.5 1.7 3.7 2.9 1.3 6.5 4.9 6.3 9.8 3.1 5.7 6.3 11.2 12.6 16.9 18.7 5.2 5.6 10.4 11.4 16.4 16.1 3.3 2.5 8.3 3.2 12.6 4 3.6.8 7.4.8 11.1 1.2.6.1 1.3.4 1.5.7 6.3 8 17.3 7.4 24.9 13.2 2.3 1.8 5.8 1.8 8.8 2.5 2.3.5 4.6.8 6.9 1.7-8.1 2.5-15.6 2-22.5-3.3-1.4-1.1-4-.6-6.2-.7-2.5-.1-5.1.1-7.6-.4-3.7-.7-6-.2-5.6 4.2.1 1.4 0 2.7 0 4.2 0 7.7 0 7.6 8 6.4 6.7-1 7.9 4.5 10.2 8.7 4.5 8 8.5 16.3 13.6 23.9 2.3 3.5 6.5 6 10.5 7.9 6.4 3.1 9.4 8 9 15.1-5.7-1.1-12.3 0-17.4-5.5-1.7-1.9-5.8-1.8-8.9-2-4.4-.4-7.6-1.5-11.4-4.5-5-3.9-10.6-7.5-17.9-9-6.9-1.5-13.6-3.1-20.6-2.7-.1 0-.4-.1-.5-.2-15.2-6.2-18-4.4-16.4 12-6.4-1-11.1-3.9-13.6-9.8-2-4.6-4.5-6.8-10.1-5-2.9 1-6.7-1.2-9.6-.4-6.9 1.9-13.5 4.9-20.1 7.4-1.1.4-2.4 1.7-3 1.4-4.8-2-9.5-3.9-13.8-6.5-3.7-2.3-6.7-5.2-11.7-4.3-1.5.4-3.8-.6-5.2-1.7-4.5-3.6-9.2-6.9-13-11.2-8.6-9.5-17.1-19.3-24.9-29.5-4.9-6.5-6.3-7.9-13.2-3.5-5 3.1-9.6 3.7-15.1 1.7-2.6-1-5.7-.5-8.6-1-1.7-.2-3.5-.7-4.6-1.7-8.6-6.7-12.5-6.4-17.9 3-2.6 4.5-4.9 6.9-10.2 3.9-.2-3.1-.5-6.5-.7-10.1-.2-3.9-2.6-5.6-6.1-4-5.2 2.5-10.2 5.6-16.3 9-6-1.2-13.3-2.6-21.4-4.3 1.8-6.3-2-9.4-7.7-12-6.1-2.9-11.6-6.8-17.5-10.2 5.4-4.9 11-8.9 15.1-14.1 2.6-3.2 2.9-8.2 5-11.9 2.1-3.5 4.6-6.3 2.7-10.7-.4-.8.1-2.5.8-3.2 3.9-4.3 8.2-8.3 11.9-12.9 2.6-3.2 4.5-6.9 7.1-11.1 4.3-.6 10-1.4 16.3-2.4-1.9 5.8-4.4 11.1-5.4 16.6-1 5.6-.2 11.4.5 17.7 7.3-5.8 13.3-4.8 18.9 1 9.4-2.1 18.2 7.3 28.1 1.1 3-1.8 6.4-.7 8.1 3.9 3.1 8.7 5.4 9.5 15.2 8.7 2.7-.2 6.2.8 8.3 2.5 4.8 3.6 9.8 2.4 14.8 2.3 2.4-.1 4.6-.5 7-.6 1 0 2.3.7 2.9.4 7.7-6.2 13.7-1.3 20 2.9 1.1.7 4.3.4 4.9-.5 2.1-3.1 4.3-2 7.1-1.4 4.4.8 9 1 13.5.4 1.3-.1 3-3.5 3.2-5.5.5-4.4.2-9 .2-14.6z"/>
        <g class="item-text">
          <path class="st2" d="M701.1 233.8h134.4V266H701.1z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 708.745 259.111)" class="st3 st4 st5">
              Sucumbios
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="imbabura">
        <path class="st1" d="M403 213.5c-1.1-2.9-2-5.4-3.1-8.3 4-1.1 8-3 12-3.1 7-.2 13.9.5 19.9-4.9 2.6-2.4 6.2-1.7 8.9 1.3 3.3 3.7 6.9 2.5 9.6-.7 4.2-4.8 7.7-10 12-14.5 2.1-2.3 5-4.9 7.9-5.1 6.8-.7 8.1-5.6 9.9-10.4 1.7-4.6-.8-7.7-4-10.8-2.4-2.3-4.2-5.2-6.2-8 .6-.2 1.1-.6 1.7-.8 1.8-1.4 4.2-2.6 5.2-4.5 3.5-6 8.8-4.6 12-1.9 8.3 7 16.1 15 23.5 23.1 2 2.3 1.8 6.7 2.4 10.1 1.4 8.3 4.3 10.8 12.6 12.1 3.1.5 6.2 2.3 8.9 3.9 2.7 1.5 5.1 3.7 7.7 5.4 2.4 1.4 5 2.5 6.5 3.2-.7 4.2-1.2 7-1.8 9.9-.2 1.1-.6 2.9-1.4 3.1-5.1 1.9-7.5 8-15 7-6.1-.8-13 2.1-18.9 4.6-8 3.2-11.6 3.1-17.7-2.7-3.3-3.1-6.3-7.3-10.2-8.7-5-1.8-11-1.9-16.2-1.3-6.8.8-13.2 3.8-20 4.6-3.9.5-8.2-1-12.1-2.1-7.1-2.1-14.1-3.1-21.4-1-4.2 1.5-8.6.5-12.7.5z"/>
        <g class="item-text">
          <path class="st2" d="M457 177.4h116.9v30.3H457z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 463.52 202.099)" class="st3 st4 st5">
              Imbabura
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="pichincha">
        <path class="st1" d="M490.8 225.4c6.7 7.1 11.7 9 23.5 4.8 5.8-2 11.6-4 18.6-6.4-.2 13.7 13.3 11.8 19.8 19.4-2.5 1.2-4.6 2-6.5 3.2-1.8 1.1-4.8 2.6-4.8 3.9-.1 9-9.2 7.5-13 11.8-4.8 5.5-10.8 4.6-16.6 5.7-1.8.4-3.3 1.1-5.7 1.8 0 4 .6 8.5-.1 12.7-.6 3.7-2.1 7.5-4.3 10.5-2.4 3.3-3.5 6.2-3.9 10.5-.7 5.4-.4 12.1-6 16.2-.5.4-1 .8-1.1 1.4-.7 7.1-6.5 10.4-11.7 14.5-3.6-3.8-7.1-7.7-11-11.6-.8-.8-2.1-1.8-3-1.7-6.3 1.4-14.2-1.9-18.7 5.7-.6 1-2.7 1.8-3.3 1.4-1.2-.7-2.6-2.4-2.5-3.6.2-6.9-2.9-10.2-9.8-10.6-1.4-.1-3.3-1.7-4-3.1-3.3-6-6.4-12-9.9-18.7 12 5.1 15.5-5.7 21.7-11.1 2.5-2.3 1.3-5.6-1.8-7.4-1.7-1-3.6-1.5-5.5-2.4-3.2-1.4-5.7-3.2-5.2-7.5.6-4.5-2.1-5.8-5.8-4.2-3.7 1.5-6.8 1.2-9.9-1.3-.8-.7-2.1-1.1-3.3-1.2-6.5-.7-13.2-1.3-19.6-2 1-2.9 2.9-5.8 2.1-7.1-1.1-1.7-4.2-2.5-6.5-3-8.6-1.9-17.3-3.6-25.8-5.4 1-9.5 12.9-16.8 2.9-26.1 3.1-2.9 6-5.5 9.6-8.9 5.6.6 12.4 1.4 19.2 2 4.2.4 7.4 1.7 8.7 6.3 1.1 3.8 3.8 5.8 8.1 5.4 5.2-.6 10.5-1.5 15.7-1.7 4.3-.1 8.6.5 12.7 1.4 7.6 1.8 14.6 3.9 23 1 7.9-2.7 16.7-2.6 24.8-3.8 1.1 4.2 2 7.6 2.9 11 1.5-.3 3.4-.9 6-1.8z"/>
        <g class="item-text">
          <path class="st2" d="M429.2 226.4h115.3v32.4H429.2z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 435.3 251.95)" class="st3 st4 st5">
              Pichincha
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="cotopaxi">
        <path class="st1" d="M477.7 382.5c-1 1-3 3.3-4.8 5.2-3.3-1.7-6.2-3.8-9.3-4.2-1.9-.2-5.1 1.5-6.2 3.3-2.4 3.7-12.1 9-16.4 7.7-7-2-13.7-3-19.4 3.2-.8 1-3 1-4.4 1.3-4 1-8.1 2.4-12.3 2.5-3.1.1-6.7-.7-9.4-2.3-8.6-4.9-19.9-4.2-27.6 2.5-.5.4-1 .6-1.4.8-8-7.4-1.5-14.8-.4-22.3.5-3 .6-6.2.8-9.2-.7-.2-1.4-.5-2.1-.8 2.5-3 5.7-5.5 7.4-8.8 4.8-10.1 15.4-17 16-29.5.1-3.1 2.3-5.8 6.7-5.7 6.5.1 11.7-10.1 8.2-15.8-2-3.3-1.9-5.8 1.7-8.2 2-1.3 3.5-3.7 6-6.4 3.1 4.9 6.5 9.5 8.9 14.5 2.5 5.4 5.1 9.6 11.7 10.5 1.3.2 3.1 2.3 3.5 3.8.8 4.3 1.5 8.6 6.3 9.9 4.3 1.2 7.9-.5 10.8-4.2 3.1-3.7 11.1-2.6 14.5 1.2 2.6 2.9 6 5 8.6 7.9 5.7 6.1 5.6 12.6 3.2 20.6-2.1 6.5-.6 14.1-.6 22.5z"/>
        <g class="item-text">
          <path class="st2" d="M373.4 338.2h109.2v33.5H373.4z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 379.6 361.7)" class="st3 st4 st5">
              Cotopaxi
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="pastana">
        <path class="st1" d="M668.3 580.4c2-6.7.5-9.5-3.5-12.5-3.5-2.6-6-6.9-7.9-11-3.8-8.1-13-8.6-18.6-13.9-1.8-1.7-3.9-3.1-5.8-4.8-.5-.4-.7-1-1.2-1.3-4-4.3-31.2-17.5-37-18.2-1.7-.2-3.3-1.1-4.9-1.7-1.8-.8-3.6-2.6-5.2-2.5-11.1.2-16.2-8.3-22.4-15.1-2.3-2.5-3-6.5-4.3-9.9-1.9-5-4-9.9-5.6-14.9-3.3-11.7-7.1-13.9-19.1-10.6-4.2-9.9-4.5-22-16-27.5 1.1-12.9-.2-15.5-11.1-24.1 6.4 1 12.9 1.9 19.3 2.7 6.4.8 13 1.7 19.4 1.9 2.3.1 4.6-1.9 7-2.7 2.9-1.1 5.8-2.3 8.8-2.9 30.4-6 60.7-11.8 91.1-17.7-.2.5-.5 1.1-.8 1.5 3.5 1.9 6.9 4.3 10.6 5.8 6.1 2.5 12.3 4.4 18.5 6.7 4.8 1.7 7.7.6 8.1-5 .2-3.1 1.7-3.6 5-3.8 6.9-.6 14.1-1.9 20.4-4.5 7.4-3.1 12.9-.8 13.1 6.8.2 6.2 8.2 14.2 14.3 15 3.3.4 6.4 2 9.6 3.2 2.1.7 4.4 2.4 6.5 2.3 8.1-.6 16.3-2.9 24.3-2.3 6.7.5 13.3 3.6 19.6 6.4 4 1.8 7.3 4.4 12 1.9 1.5-.8 4.5-.2 6.1.7 5.4 3.6 10.2 7.6 15.5 11.3 2.9 1.9 6 3.6 9 4.9 8.1 3.5 8.5 4.5 3 11.6-13.9 17.5-28.6 34.5-41.6 52.7-13.2 18.3-31.6 30.4-48.5 44.4-12.6 10.5-25.7 20.5-38.6 30.7-6.7 5.2-8.8 5.1-15.4.1-1.5-1.2-3.9-1.3-5.8-1.8-1.1-.2-2.6.2-3.1-.4-3-3.3-5.1-1.3-8.6-.4-4.4 1.3-9.9-.5-16.2-1.1z"/>
        <g class="item-text">
          <path class="st2" d="M657 454.2h94.8v29.9H657z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 660.69 478.166)" class="st3 st4 st5">
              Pastana
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="orellana">
        <path class="st1" d="M591 368.6c.6-6.3.8-11.6 1.7-16.7.4-2.4 1.4-4.9 2.7-7 2.7-4.4 3.6-8.9.5-13.3-3.8-5.5-8-10.7-12.3-16.4 3.5-2.4 6.9-6.2 13.7-2.7 7.9 4 12.3 2 17.6-5.4 1-1.3 2.5-2.6 4-3.1 3.5-1 5.8-2.3 5.2-6.4-.1-.7.8-2 1.4-2.1 3.9-.7 3.9-4 5.6-6.7 4.6-7.5-.1-12.4-2.4-18.1-.8-2-1.1-4.3-1-6.4.1-2.9 1-5.7 1.5-8.5 13.6 7.4 27.7 10 42.7 2.4 3.8 5.5 7.3 11.3 11.7 16.3 5.8 6.5 12.3 12.6 18.5 18.8 3.5 3.5 7 6.9 11 9.8 2.1 1.5 5.1 2.3 7.9 3 2 .6 5.4-.1 6.1 1 4 6.4 11.3 6.5 17.1 9 2.1 1 5.4.8 7.6 0 8.6-3.2 15.8-10.7 26.3-7 1.4.5 3.5-.5 5.7-.8 3.7 8.8 11.2 13.6 20.4 15.7 5.5 1.3 7.5-.7 6.4-6.2-.4-1.5-.6-3.1-.7-4.6-.1-1.5.1-3.1.2-5.2 1.8.2 3.3.2 4.8.6 4 1 8.1 2.6 12.3 2.9 3.8.2 7.3-.2 10.2 2.7.7.7 2.3 1.2 3.2 1 7.9-1.2 12 3.5 16.1 9 1.1 1.4 3.5 2.5 5.4 2.7 3.7.6 8.1-.7 11.1 1 6.1 3.3 11.6 7.4 18.7 8.2.6.1 1.3 2.4 1.2 3.6-.8 8 2.1 14.9 4.8 22 1.1 3.1.2 6.8.2 10.1-5.1 3-8.7 2-11.9-2.5-1.5-2-4.4-3.1-7.4-5.2-7.5 27.4-14.8 53.8-21.9 79.8-4.2-1.9-8.1-3.6-11.8-5.5-3-1.5-5.8-3.2-8.6-5-5.6-3.7-10.8-7.7-16.6-11-3.1-1.8-6.8-3.7-10.5-.5-.7.6-2.7.6-3.7.1-4.3-2-8.3-4.5-12.5-6.7-5.1-2.6-10.1-3.2-16.2-1.7-6.9 1.8-14.4 1.4-21.7 1.8-1.1 0-2.1-1.7-3.3-2.1-3-1.3-6-3.1-9-3.6-6.7-1.1-11.2-5.7-11.1-12.4.1-5.4-1.9-8.8-7.6-9.4-4.2-.4-8.2-.7-12.4-1-.7 0-1.9 0-2.3.5-5.1 7-12.4 3.9-19.1 4.9-3 .4-6.5 3.1-8 5.7-1.9 3.3-3.3 3.6-6.4 2.4-4.8-1.9-9.6-3.5-14.5-5.1-4-1.4-5.5-8.6-3.5-13.9 1.7-4.5 3.6-9.5 3.3-14.2-.4-5.1-5.5-6.4-10-6.1-6 .5-7.3-5.7-11.7-7.4.7-2 1.1-4.4 2.4-6 2.1-2.7 5.7-4.6 7.3-7.7 1.1-2-.2-5.4-.5-8-2.3.5-5.2.1-6.8 1.4-6.2 5.5-11.4 12.1-17.9 17.3-4.3 3.3-10.2 4.6-15.2 7.3-4.3 2.1-8.3 4.6-12.4 7.1-1.8.9-3.8 2.2-5.6 3.5z"/>
        <g class="item-text">
          <path class="st2" d="M748.2 354.9h103.4v32.2H748.2z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 754.659 379.93)" class="st3 st4 st5">
              Orellana
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="guayas">
        <g>
          <path class="st1" d="M374.3 533.4c-2.1.4-3.8.2-4.8 1.1-1.5 1.4-2.6 3.5-3.8 5.1 1.7 1 3.2 2.3 5 2.6 2 .5 4.3.1 6.9.1-1.5 4.8-2.9 8.3-9 7-2.7-.6-6.3.7-9 2-4.2 2-7.7 5.5-13 2.3-.6-.4-4.6 2.5-5 4.2-1.1 6.7-5.7 10.6-10 14.9-1.4 1.3-3.2 4.6-2.6 5.2 1.7 2 4.3 3.5 6.8 4.5 1 .5 2.6-.4 3.9-.8 7.4-2.7 7.9-2.4 8.5 6.1-4-1.8-7.4-1.5-8.3 3.5-.1.4-.8.7-1.3.8-7.6 1.9-12.3 9.3-11.1 18 .2 1.9.6 3.9 1.1 5.8 1.3 4.6 2.6 8.7-4.8 9.5-2.1.2-4 4.3-5.5 7-1.1 2-1 4.6-1.4 7.6-2-.7-3.7-1.7-5.5-1.9-3.6-.6-7-1.2-8.8 3.6-2.7 7.6-3 7.6-11.8 4.9-.4-9.3-1.9-18.7 3.1-27.6 1.8-3.1 2-7.1 2.6-10.8.6-4.3 1.7-8 6-10.2 1.5-.8 2.4-3.1 3.6-4.8-1.9-.2-3.9-.5-5.8-.6-1 0-1.9.4-3.2.7-1.1-4.4 1-7 4-9.6 1.3-1.2 1.7-3.5 2.5-5.4-2-.2-4.2-1-6-.5-5.1 1.5-8.2 5.1-9 10.6-.4 2.3-1.2 4.4-1.8 6.7-.5-.1-1-.2-1.5-.4 1.2-4.6 2.4-9.3 3.5-13.9 1.1-5 2.6-10 3-15 .2-4.5 1.2-10.2-6-13-.8 6-1.4 11.1-2.1 16.6-5 1-10 1.8-15.4 2.7.6-9.3 6.2-13.2 12-17.4 1.3-1 1.1-4.3 1.4-6.7-1.7-.1-3.3-.5-4.9-.1-4 1.1-8.5 1.7-10.6 6.3-1.2 2.5-4 4.3-4.9 6.8-4.2 12-10.7 21.7-21.7 28.6-4.8 3-10.4 7.5-8.5 16.1-11-8.2-22-16.4-33.3-24.9 4.3-1.4 8.1-1.5 9.9-3.6 1.9-2.1 1.9-6.1 3-9 .6-1.4 1.4-3.5 2.7-3.8 5.1-1.8 10.4-3.5 15.7-4.3 5.2-.8 10.2-7.3 9.8-12.6-.6-6.7 0-13.5-.8-20.1-.4-3-2.9-5.8-4.9-8.2-1.8-2.1-5.1-3.2-6.5-5.6-2.7-4.5-6.1-7.5-11.2-8.6-.8-.2-2-1.9-2-2.9-.1-3.7-.7-7.6.6-10.8 2.4-6.2 4-13.2 11.2-16.1 3.3-1.3 6.8-2.7 10.4-3.3 8-1.2 8.5-1.7 6.2-9.2-.6-2-1.7-3.9-2.5-6.1 2-1.5 4.6-2.9 6.2-4.9 1.1-1.5 1.4-4.2 1-6.1-1.1-4.6-2.7-9 2.7-12.3 1.1-.6 2.4-2.5 2-3.3-2.1-6.2 2.5-6.5 6.4-8.3 8.7-4 14.1-11.2 15.4-20.8 7 .4 19.1-8.1 22.7-15.7 2.1-4.4 4.4-8.7 6.7-13.1 1.7-3.3 3.2-5.5 8.1-4.3 2.9.7 6.8-2.1 10.1-3.6 3.1-1.3 6.1-2.9 10.6-5-.8 9.2-1.4 16.6-2.1 23.9-.4.4-.6.8-1 .8-14.2 2.9-24.2 10.6-30.4 23.7-3 6.2-7.1 11.9-10.2 18-4.3 8.3-7.7 17-4 26.7.4.8.4 1.9.2 2.9-1.1 11.1 1.8 15.7 10.8 21.2 3 1.8 4 6.8 6.3 10 3.6 5 6.7 10.6 11.4 14.1 2.3 1.7 8.1-.1 11.6-1.8 6-2.9 10.4-2.6 14.5 2.7 1.5 2 4 3.8 6.5 4.6 6.4 2.3 8.3 8 11.2 13 2.1 3.9 4.4 6.9 9.8 7.5 2.4.7 5 4.4 8.4 7z"/>
          <path class="st1" d="M278.2 611.2c-2.4 1.4-4.2 2.3-5.6 3.3-3.6 3-7.9 5.5-10.2 9.3-3.1 4.9-5.7 4.9-9.9 2-1.4-1.1-3.7-1-5.6-1.3.1 2.1-.4 4.5.5 6.2 1.7 3.5 4.2 6.7 6.3 9.9-3 3.6-12.1 6.8-15.8 5.2-1.3-.6-3.3-2.4-3.2-3.3.8-8 1.4-16.1 3.6-23.7 2-7.3 18.2-16.6 25.5-14.9 4.6 1.3 8.9 4.6 14.4 7.3zM260.7 589c3.2-2.7 6-5.1 9.2-7.7 1.2.2 3.8 1.4 5.8.8 2-.7 3.3-3.3 4.9-5 2.7 8.1-8 10.5-8.1 18.8-4.2-2.6-7.8-4.7-11.8-6.9z"/>
        </g>
        <g class="item-text">
          <path class="st2" d="M248.6 504.9h88.3v32.8h-88.3z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 253.4 528.5)" class="st3 st4 st5">
              Guayas
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="canar">
        <path class="st1" d="M385.1 548c5.6 5.7 11.4 12.1 17.9 17.9 4.5 3.9 10 6.1 16.4 3.3 2.5-1.1 5.7-1.3 7.5 2.4.5 1.1 3.3 2.1 4.4 1.7 6-2.6 9.9-1.2 13.6 4 2 3 5.2 5.1 7.9 7.5-2.6 3.1-4.4 6.1-6.9 7.9-3.3 2.4-7.3 4.9-11.2 5.4-5.2.6-7.9 3.1-9.3 7.6-.7 2.5-1.9 4.9-2 7.4-.2 5.6-4.5 6.2-8.2 6.3-1.7 0-3.6-3.1-5.1-5-3.8-4.8-7.1-9.9-11.2-14.3-.8-.8-4.8-.1-6.2 1.1-3.7 3-13.8 4.9-17.5 2.4-1-.7-1.7-2.1-2-3.3-.5-1.7-.5-3.5-.7-5.2-1.7-11.9-1.4-11.2-13.3-13.2-1.5-.2-4.2-.7-4.4-1.5-2.3-8.1-7.9-7.6-14.8-5.2 3-4.4 5.5-8.1 8-11.8.5-.6 1.1-1.8 1.4-1.7 8.6 1.3 14.1-8.3 23.5-6.3 3.3.6 8-4.8 12.2-7.4z"/>
        <g class="item-text">
          <path class="st2" d="M375.1 567.3h75.8v30.3h-75.8z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 380.6 592)" class="st3 st4 st5">
              Cañar
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="azuay">
        <path class="st1" d="M319.4 683.2c1.1-3.3 1.3-6.1 2.6-7.9 5-7 3.2-14.3-4.8-17.7-4.2-1.8-8.5-3.2-13-5 1.4-3 2.9-6 4.4-9.2 1.4.5 2.9 1.1 4.3 1.5 6.4 2.4 9.6.2 10-6.5.2-4.2 1.1-7.1 6.1-8.7 7.9-2.4 8-5.7 5.6-13.5-1.5-5.1-.2-11.1-.1-17.9 5.8 3 10.4 6.1 11.9-2.1 5 2.7 7.9 1.9 8.2-4.2.1-1.5 2.7-4.4 4-4.3 2.5.2 5.6 1.4 7.1 3.3 1.3 1.8 1.1 4.9 1.3 7.5.7 8.3 1.7 8.7 9.8 11.6 7.4 2.5 13.3 1.3 19.9-3.8 3.6 5.2 7.3 10.4 10.7 15.6 2.4 3.6 5 4.2 9.4 3.7 8.3-1 11.6-5.7 12.6-12.9.8-5.7 2.7-9.8 9.5-9.2 6.1.5 9.8-3 12.4-8 .6-1.2 1.7-2 2-2.5 2.1 2.9 3.7 6.8 6.2 7.5 2.1.6 5.4-2.4 9.2-4.4.2.1 1.5 1 4.4 2.6-5.5 1.8-9.4 3.5-13.6 4.4-8.5 1.9-12.4 8-8.7 15.5 2.3 4.5 1.3 7.7-1.4 10.7-5.5 6-6.9 13.2-7.5 20.7-.4 4.5-1.4 7.4-6.9 8.5-3.5.7-7.3 4.4-9.2 7.7-3.9 6.8-10.4 9.8-16.6 13.2-1.1.6-2.7 1.1-3 1.8-1.9 6.8-8.3 8.7-13 12.6-1.7 1.4-3.5 4-3.3 6 .5 6-4 11.6-1.1 17.9.6 1.4-1.5 4-2.4 6.2-1.2-2-2.7-3.8-3.6-6-1.5-4.4-2.3-9.3-4.4-13.3-1-1.7-4.8-2.7-7.1-2.5-8.6.5-8.6.8-9.9-7-1.1-6.3-6.3-6.9-11-8.5-3.3-1.1-6.4-2.9-9.8-3.3-5.2-.8-10.5-.8-15.7-1.1-1.2 0-2.5.5-5.5 1z"/>
        <g class="item-text">
          <path class="st2" d="M340.2 633.5h76.7v31.8h-76.7z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 345.38 655.798)" class="st3 st4 st5">
              Azuay
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="loja">
        <path class="st1" d="M342.7 868.9c2.3-6.8-5.5-11.1-2.7-18.5 1.4-3.8-1.4-8.5-6.8-8.1-4.2.4-6.1-1.7-8.1-4.5-5.1-7.4-9.3-8.1-16.9-3.8-3.2 1.8-6.8 3.5-10.4 4-1.9.4-5.1-1.3-6.1-3-3.3-5.8-7.3-9.3-14.8-10-4.6-.4-9-5-13.2-8.1-4.9-3.7-9.8-6.1-16.2-4.8-3.2.6-4.3 1.9-5.7 4.8-1.7 3.5-4.9 6.1-7.6 8.8-2.5 2.5-5.4 4.5-7.7 7.1-3.5 3.9-9.4 5.4-12.5 1.5-1.5-1.9-1.4-7.1.1-9.4 4.3-6.4 9.8-12.1 14.6-18.2 1-1.2 1.3-3 1.9-4.5-1.7-.5-3.3-1.3-5.1-1.5-3.2-.2-6.5.1-9.8-.5-1.2-.1-2.3-1.9-3-3.1-1.5-2.9-3.7-6-3.8-8.9 0-2.9 1.7-6.4 3.9-8.3 1.9-1.7 6.4-2.7 8.3-1.5 7.6 4.5 11.7 1.7 18.1-3.7 6.5-5.5 14.2-11.6 23.8-13 3.2-.5 6.1-3.1 9.2-3.7 5.6-1.1 11.6-2.1 17.1-1.5 8.2.8 16.1 1.2 22.4-5.1 3.6-3.6 6.5-6.1 11.4-1.8 1.5 1.3 4.4 1.2 6.8 1.5 2.9.5 5.8.5 8.7 1.3 6 1.7 9.3 0 11.4-6 1.8-5.1 4.3-10 5.5-15.2.6-2.5.1-6.4-1.5-8-3.5-3.2-7.9-5.2-12.6-8.2 2.1-3.3 6.2-7 6.4-11 .2-3.8-3.3-7.9-5.7-13 4.2.7 8.1 1.3 11.8 2.4 1.1.4 2 2.3 2.3 3.6 1.5 10.4 5.1 12.7 15.6 10.2.4-.1.8 0 2.7-.2.7 4.2 1.2 8.6 2.4 12.9.8 2.9 2.6 5.4 3.6 7.1-2.4 3.8-6.2 7.5-6.9 11.7-.6 3.7 2.7 7.7 3.9 11.8 1.2 3.9 2.5 8.1 2.4 12-.2 8.9-1.4 17.9-2.3 26.7-.4 4.4-.5 8.7 3.9 11.7 1.3.8 2 3.3 2 5.1.1 6.4 0 13-.2 19.5-.2 5.5-8.1 11-15.5 11-9.5-.1-13.8 4.8-13.6 13.9.1 2.6-1.7 5.5-3.2 7.9-1.1 1.8-3.6 2.6-4.8 4.3-1.1 1.7-1.2 3.9-1.7 5.8-.5.4-1.2.4-1.8.5z"/>
        <g class="item-text">
          <path class="st2" d="M288.4 772.9h54.7v32.5h-54.7z"/>
            <text transform="matrix(1 0 0 1.1 292.324 797)" class="st3 st4 st5">
              Loja
            </text>
        </g>
      </g>
      <g class="item-a" id="zampora">
        <path class="st1" d="M406.5 693.5c2.7 6.4 5 12.7 8 18.6 2.1 4.3 4.5 8.5 10.4 9.4 9.2 1.4 14.4 9 16.3 16.3 3.5 13.2 13.3 13.2 23.1 14.8 1.9.2 3.9 0 6 0-1.2 5.1-2.1 9.9-3.6 14.5-.4 1.2-1.8 2.3-3.1 2.7-8.2 3.5-10 8.6-6.7 14.6-1 5.5-1.4 9.4-2.4 13.2-1.3 5-1.7 11.2-5 14.4-6.5 6.4-3.8 12.7-2.5 19.5.6 2.7.2 5.8-.4 8.6-1 3.9-2 8-3.9 11.4-1.1 2-3.7 3.7-6.1 4.6-4.2 1.5-8.8 2.1-13 3.7-2.3.8-5.5 2.4-6.1 4.3-2 6.5-9 11.4-6.3 19.6.7 2.1-.5 5-.7 7.9-10.4-1.1-9.3 8.3-12 14.3-9.4-4.2-18.8-6.5-28.9-4.8-.8.1-2.3-.1-2.7-.7-6.3-7.7-12.5-15.5-18.6-23.5-.6-.7.1-2.9.8-3.9 3.2-5 6.9-9.8 9.8-15 1.4-2.5 1.5-6 1.7-8.9.1-4 4.8-8.3 7.9-6.1 7.7 5.8 10.2-2.1 14.4-5 8.8-6 6.8-15.5 7.4-24.1.1-2.4 1-4.9.5-7-.8-3.5-2.5-6.7-3.8-10-.8-2.1-2.6-4.4-2.5-6.5.4-8.6 1.4-17 2.1-25.5.2-2.9.6-6-.1-8.8-.8-3.3-2.3-6.8-4.3-9.6-2.9-3.9-2.1-8.2 2.5-12.3 3.1-2.7 6.1-5.6 8.9-8.6.8-1 1.7-2.4 1.7-3.6.1-6.2 0-12.5-.2-18.7-.2-4.7 2.7-7.4 11.4-9.8z"/>
        <g class="item-text">
          <path class="st2" d="M385.9 761H507v63.1H385.9z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 393.043 786.036)">
              <tspan x="0" y="0" class="st3 st4 st5">Zampora</tspan><tspan x="0" y="23.8" class="st3 st4 st5">Chinchipe</tspan>
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="morona">
        <path class="st1" d="M699.6 591.2c-10.5 3.6-20.8 7.1-31.3 10.7-37 12.6-74.2 24.9-111 38.2-11.1 3.9-20.1 11.8-26.2 22.5-2 3.6-6.1 6-9 8.9-1.3 1.3-2.4 3-3.6 4.4-3.3 4-6.3 8.3-9.9 12-3.1 3.1-3.5 7.9 0 12 1.2 1.5 2.3 3.3 3.5 5.2-4.4 2.4-6.8 1.4-6.7-2.6.2-7.1-4.2-8.8-9.9-9.2-1.2-.1-2.4-.2-3.5-.6-5.2-1.8-7.1.5-7.4 6.1-.2 5.6-2.1 11.2-3.3 16.8-.4 1.7-1.1 3.3-1.5 5-1 3.7-.2 8.5-6.3 8.9 1.3.8 2.7 1.8 3.2 2 0 3.6-.5 6.5.1 9.3.7 3.1.1 4.8-3.1 4.6-7-.2-13.9-.6-21-1.4-1.4-.1-3-2.4-3.7-4-4.8-12.5-11.9-22.4-25.2-26.7-1.3-.4-2.5-2-3.1-3.3-2.5-5.7-4.6-11.6-7.3-17.1-1.1-2.3-2.7-4.3-4.2-6.4.2-.4.5-1.2 1-1.3 9.4-3.8 16.9-9.9 22.3-18.6 1-1.4 3.1-3.1 4.6-3.1 6.8 0 9-4.6 9.8-9.9 1.1-8.8 2.9-16.9 8.7-24.1 2.7-3.3 4.5-7.6.8-12.5-2.6-3.5-.6-7.3 3.6-8.6s8.3-2.5 12.4-3.9c6.8-2.5 7.6-6.8 2.3-11.8-1.3-1.2-3-1.9-3.6-2.4.4-8.2 1.1-15.8 1-23.5 0-2.5-1.5-5.5-3.3-7.5-2.3-2.5-2.5-4.2-.8-7.1 3.6-6.2 8.2-12.5 4.2-20.6 5-3.2 8.7-6.4 5.5-13.5-1.4-3.1 2.9-8.2-3.5-10.5 2.6-4 5-7.6 7.4-11.2 3.8-5.5.7-10.6-1.7-15-2.1-4-1.1-6.7 2-8.3 7.6-4.3 9-10.7 8.1-18.7-.7-6.5 1.5-8.3 8.3-7 6.1 1.2 10.1-2 13.7-6.5 7.6 1.7 9 8.1 11.4 13.8 1.3 3.1 1.8 6.5 3 9.6 1.9 4.8 5.5 7.1 10.4 4.6 4.4-2.1 6.4.6 8.1 3.3 2.1 3.7 3.7 7.9 5.2 11.9 1.5 3.8 3 7.7 4 11.7 3.1 11.9 13 17.9 22.3 23.7 4.8 3 11.4 2.9 17.1 4.8 4.9 1.7 9.4 4.3 14.2 6.5 1.8.8 3.5 2 5.2 2.5 6.7 2 12.4 5.1 17.3 10.7 3.7 4.2 10 6.1 14.6 9.5 3.5 2.6 6.9 5.7 9.3 9.4 3.6 5.6 9.8 9.9 9.3 17.7 0 1 1.4 2.4 2.5 3 6.3 4 13 5.5 20.7 4.2 4.2-.7 8.7.5 13.1.8-.1 1.2-.1 1.9-.1 2.6z"/>
        <g class="item-text">
          <path class="st2" d="M498.3 570.3h108v63.2h-108z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 505.7 595.117)">
              <tspan x="0" y="0" class="st3 st4 st5">Morona</tspan><tspan x="0" y="23.8" class="st3 st4 st5">Santiago</tspan>
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="eloro">
        <path class="st1" d="M334.6 687.5c1.5 6 3 11.4 4.6 17.6-6.8 4.2-4.6 13.1-5.4 20.6-.5 5.1 3.7 5.4 10.1-.1 1.5.8 3.2 1.7 3.9 2-1.3 5.6-2.4 10.6-3.9 15.4-.4 1.2-2.9 2.5-4.3 2.4-3.8-.2-7.7-1.1-11.6-1.8-1.2-.2-2.4-.5-3.3-1-2-1.2-4-3.9-5.6-3.6-3.3.7-6.9 2.4-9.3 4.8-6.1 6-12.5 7-20.7 5-6.4-1.7-13.1-1-19.5 2.4-5.5 2.9-11.6 4.3-17.3 6.3-4.8-11.6-6.1-22.3-6.2-33.5-.1-6.2-3-12.3-4.9-19.5 3.5-1 7.7-1.8 11.8-3.2 1.4-.5 2.5-2.3 3.7-3.5-1.4-1.1-2.7-2.6-4.3-3-2.3-.5-4.9-.1-7.3-.1-.1-.7-.2-1.3-.4-2 1.5-.6 3.1-1.3 4.6-1.9 2.9-1.2 6.2-1.8 8.6-3.7 6.2-4.9 11.9-10.2 17.7-15.6 4-3.7 9.2-6.3 9-13.6-.1-4.3 7-5.7 12.6-3.1 5.5 2.5 11.1 5 16.6 7.4 5.7 2.5 6.1 4.9 3 10.4-2.3 3.8-3.5 8.2-4.4 12.6-.1.8 3.5 3.5 5.2 3.5 6.1-.1 11.9-.9 17-1.2z"/>
        <g class="item-text">
          <path class="st2" d="M254.6 695.7h73.1v31.6h-73.1z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 259.4 720.476)" class="st3 st4 st5">
              El Oro
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="santaelena">
        <path class="st1" d="M203.9 572.5c-7.9 2.4-13.1-.5-18.5-5.4-3.9-3.6-9.3-6.4-14.4-7.4-10.5-1.9-16.9-8.7-23.8-15 7.1-4.6 14.5-8.2 20.2-13.5 5.1-4.6 8-11.3 4.8-18.8-.2-.7-.8-1.7-.6-2.1 5.8-13-.7-23.9-5.6-35.1-.4-.7-.5-1.4-.8-2.5 6.5-1.1 12.9-2.4 19.2-2.9 1.2-.1 3.9 3.1 3.8 4.8-.4 9.2 2.6 17 7.9 24.3 1.2 1.7 3 3 4.8 4 8.8 5.5 18.5 10.1 24.5 19.1.6.8 1.1 1.7 1.8 2.3 1.7 1.2 4.8 2 4.9 3.2.5 4.8-.1 9.5-.2 14.3-.1 2-.6 4.3-.1 6.2 1.1 4-1 4.8-4.3 5.6-6.9 1.9-13.7 4.3-20.4 7.1-1.5.7-2.5 3.7-3.1 5.8-.5 2.1-.1 4.4-.1 6z"/>
        <g class="item-text">
          <path class="st2" d="M136.4 506.6h78.9v57.7h-78.9z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 145.104 530.8)">
              <tspan x="0" y="0" class="st3 st4 st5">Santa</tspan><tspan x="0" y="23.8" class="st3 st4 st5">Elena</tspan>
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="manabi">
        <path class="st1" d="M206.9 497.6c-4.9-1.1-11.3-8-11.7-13.7-.4-5.1-.2-10.2-.6-15.2-.1-1.4-1.1-3.9-1.8-3.9-4.3-.1-7.7-3.8-13-1.7-5 2-11.1 1.9-16.7 1.9-1.4 0-3.2-3-4.3-4.9-.5-.8.4-2.6 1-3.8 3.5-7.4 7.1-14.6 10.6-22 3.7-7.9-.6-13.5-5.1-19.5-5.5-7.4-9.8-15.7-14.4-23.7-.7-1.2-.6-3.7.2-4.8 4.4-5.7 8.8-11.7 17.1-11.8 4.3 0 8.8-.7 13 .1 5.5 1.2 9.4-.6 12.3-4.9 2.4-3.6 4.3-7.5 5.8-11.6 4.3-10.6 8.3-21.2 12.4-31.9.6-1.7.7-3.8.4-5.5-1.8-7.1-3.8-14.3-6-21.7 5.4-4.2 10.7-9.3 13.1-17 .7-2.5 3.5-5.1 6-6.2 13.2-5.7 21.6-16.6 30.6-27 7-8 8.1-17.9 10.5-26.9 2.4 1.3 4.8 3.7 6.2 3.2 2-.6 3.8-3.1 4.9-5.1 3.1-5.8 5.2-12.3 14.1-11.6 1.5.1 3.3-3.3 4.9-5.2 1-1.2 1.8-2.5 2.6-3.8.8 1.4 1.7 2.9 2.5 4.4.1.1-.1.5 0 .6 2.7 6.1 6.2 12 1.7 18.9-.4.5 3 4.4 5.2 5.5 8.8 4 8.7 3.8 6.5 12.4-.5 1.8.1 3.8.5 5.7.4 3 1.3 5.8 1.4 8.7.4 10.8 5.4 16.1 16.1 16.4 8.9.2 10.1 1.4 10.4 10.5 0 1.9.4 3.9.7 5.8.7 5.4 0 9.8-3 14.9-3.8 6.4-8.5 12.9-8.8 21.2-.2 5.7-3.7 10.7-8.8 14.6-2.5 2-3 6.8-3.9 10.4-.7 2.6-.2 6.2-1.8 7.9-1.9 2-5.7 3.6-8.3 3.1-4.6-.7-7.7.1-9.9 4.2-3 5.5-5.5 11.3-9.2 16.2s-8.5 8.9-13.2 13c-.8.7-3.3-.1-5-.7-4.3-1.5-6 .4-6 4.4 0 11-4.6 16.1-15.6 19.2-2.6.7-4.2 5.4-6.1 8.2-1.1 1.5-1.8 3.3-2.7 5-.6 1-1.8 1.8-1.9 2.7-.5 5.2-.8 10.5-1.2 16.4h-5c-5.1.1-6.9 3-4 7.4 1.8 2.7 4 5 7.6 9.2-10.6-1-16.7 3.5-22.3 9.8-6 6.5-8 13.7-8 22.2z"/>
        <g class="item-text">
          <path class="st2" d="M178.2 331.9h102.9v29.8H178.2z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 185.808 355.94)" class="st3 st4 st5">
              Manabí
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="napo">
        <path class="st1" d="M558.5 246.5c0 2.9-.8 5.5.2 7 1.5 2.5 4.2 5.6 6.7 6 4.4.7 9.2-.4 13.7-.6 1 0 2.3 0 2.7.6 4.9 5.5 8.5 2.1 12.4-1.5 1.9-1.8 4.5-2.9 6.9-4.3 3.6 3.8-1.5 10.7 5.4 12.3 4.3 1 8.6 1.7 14.6 2.9 1 3.1 2.7 7.7 3.8 12.6.5 2.1 0 5.2-1.3 6.9-5 6.3-10.4 12.4-16 18.2-1.1 1.2-4 1.3-5.8.8-3.8-1.1-7.4-3-11-4.4-3.2-1.3-5.4-.6-7.3 2.7-1.7 2.9-4.8 5-7.1 7.5-3.7 3.9-3.2 6.3 1.5 8.5 6.7 3 10.2 8.9 13.1 15.1.7 1.4-.8 3.9-1.3 5.8-1.1 4.3-1.9 8.7-3.1 12.9-1 3.2-1.9 6.8-3.7 9.5-3.2 4.8-2.1 8.9 3.6 9.2 4 .1 9.4-.7 11.9-3.3 7-7.5 16.8-8.6 25-13.2 3.3-1.9 6.5-4 10-6.3 1.3 2.5-2.5 8.8 5.7 11 4.2 1.1 7.7 6.3 13 4.8.4 3.6.6 6.7 1.1 10.5-.7 2.4-1.7 5.7-3 9.9-11.4 2.4-23.7 4.9-36 7.4-20.8 4-42.4 6.2-62.5 12.7-15.5 4.9-28.9-.5-43.2-1.3-3.3-.2-6.7-1.1-9.9-1.7-5.1-.8-6.5-3.5-5.7-8.6.7-4.2 1.4-8.7.7-12.7-.5-2.6-3-5.6-5.5-7-4.9-3-7.5-8.6-3.8-13.3 5.4-6.9 3.2-13.8 1.1-20.6-1.1-3.5-.1-4.8 2.6-6.5 2.4-1.5 4.2-4.2 6-6.5 1.7-2 3.1-4.3 4.4-6.4 1-1.7 1.9-3.3 2.5-5.1 1.2-3.5 2-7 3.1-10.6.1-.6.8-1.2.6-1.5-3-6.3 3.3-9 5-13.6 1.4-4 1.7-8.7 1.9-13.1.4-6.1 1.1-6.2 7-4.9 2.6.6 6.8-.5 8.5-2.4 3.5-3.9 7.6-5.2 12.1-7 2.7-1.1 6.5-4.3 6.5-6.7.1-5.2 3-6.8 6.8-8.2 1.8-1.1 3.5-2 6.1-3.5z"/>
        <g class="item-text">
          <path class="st2" d="M508.7 331.1h73.2v32.7h-73.2z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 517.314 354.94)" class="st3 st4 st5">
              Napo
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="esmeraldas">
        <path class="st1" d="M421.7 71.2c5-8.7 6.2-9.2 13.3-3.3 4.2 3.5 7.4 8.1 11.4 11.8 2.1 1.9 4.9 3.1 7.5 4.5 3 1.5 8 2.5 8.5 4.6 1.1 4.2 1 9.8-1 13.3-3.1 5.7-4.4 18-.6 23.2 3.2 4.5 6.3 9.3 9.5 13.9-7.4 2.6-9.3 13.5-3.6 19.1 1.1 1.1 2.7 1.8 3.7 3 1.3 1.7 3.5 3.9 3.2 5.6-.2 1.7-2.7 3.8-4.6 4.3-9 2-12.6 10.1-18 16.1-1.8 2-3.2 4.4-5.1 6.9-7.1-7-13.8-4.8-20.6-.1-1 .6-2.1 1.7-3.1 1.5-13.7-1.3-26.9 6.7-41.1 2.3-4.3-1.3-9.8.6-14.6 1.2-.6 0-1.5.2-1.7.5-1.7 6-7.1 8.6-10.7 12.7-1 1.1 0 5.1 1.4 6.5 4 4.3 1.1 8.1-1 11.1-1.1 1.8-5 2.5-7.6 2.4-6.4-.5-12.9-2.6-19.2-2.4-6 .2-9.8-1.9-13.5-5.8-1.1-1.2-2.9-1.9-4.5-3 4.4-4.5 3.1-9.2-.8-13.7-.8-1-1.5-2.3-1.5-3.5.1-5.6-2.5-9.6-7.7-10.2-4.5-.6-7 2.1-9 6.1-.8 1.7-3.1 2.9-5 3.7-3.1 1.4-6.3 2.4-10.6 3.9-.1-1.5-.6-4-.5-6.5.2-4.3-.4-7.7-4.4-10.2-3.7-2.3-6-4.4-1.5-8.9 4.9-5 2.3-18.1-4.3-21.2-6.5-3.1-5.5-8.2-4.4-12.9.5-2.1 4.2-3.9 6.8-5 5.2-2 10.7-3.3 16.1-5.1 9.2-3 16.9-8.1 23.7-15.1 1.9-1.9 6.1-4.2 9.3-.1.5.7 2.6.7 3.6.2 9-4.6 17.6-10.4 27.1-13.7 6.1-2.1 13.5-1.2 20.1-1.2 9.5.1 17.3-3.6 23.2-10.7 3.6-4.4 6.8-9.2 10.1-13.8 2.6 1.4 4.8 3 7.1 3.7 1.5.5 3.6-.2 5.2-.5-.4-1.8-.4-3.8-1.2-5.5-.6-1.3-2.1-2.3-4.6-4.6 2-1.8 3.9-3.3 6.5-5.5 1.2 3.3 1.8 7.3 2.6 7.3 4.2.2 8.3-.6 12.5-1-.5-1.4-.6-3.3-1.5-4-1.1-1.4-3.2-1.4-4.9-1.9z"/>
        <g class="item-text">
          <path class="st2" d="M267.4 108.6h138.5V143H267.4z"/>
          <g>
            <g>
              <g>
                <text transform="matrix(1 0 0 1.1 273.908 135.14)" class="st3 st4 st5">
                  Esmeraldas
                </text>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g class="item-a" id="tungurahua">
        <path class="st1" d="M488.2 382.1c-.2 4 .4 8.2-.7 11.9-2 7.6 1.5 16.8 8.6 20.5 3.8 2 8.2 3.7 11 6.8 2.5 2.7 5.1 7.9 4 10.6-1.5 4.2-6.3 10.1-9.5 10-10-.4-20.8 1.2-29.6-6-2.7-2.3-5.2-2.1-8.1 1-4.8 5-18.5 5.6-23.6 1.7-10.1-7.9-10.1-7.9-21.2-1.4-6.1-5.8-7.4-12.3-2.1-19.5.7-1 1.2-2.1 1.4-3.2 3.8-13.7 8.8-16.8 23.1-13.8 3.7.7 6.8 1.2 9.6-2 .8-1.1 2.9-1.4 4.3-1.5 6.9-.4 6.9-.2 7.5-7.7 4.5 1.2 7.9 8.3 13.3 3.3 3.6-3.3 6.5-7.1 9.8-10.8.8-.1 1.5 0 2.2.1z"/>
        <g class="item-text">
          <path class="st2" d="M418.2 404.7h144.4v34H418.2z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 426.4 429.568)" class="st3 st4 st5">
              Tungurahua
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="santodomingo">
        <path class="st1" d="M348.9 241.3c2.4 1.5 4.5 3.9 7.1 4.6 8 2.1 16.1 3.7 24.4 5.6-.4 2-1.2 3.9-.7 5.4.6 1.8 2 4.3 3.5 4.5 6.9 1.2 13.9 1.7 21 2.5 1.3.1 2.6.6 3.9 1 3.8 1.2 7.5 2.4 11.9 3.8.5 6.5 7.1 8.2 12.6 10.8-5.6 12-15 9.3-22.5 6.3-4.8 5-8.5 9.2-12.4 13.2-4.2 4.2-4.3 11.3.1 15.7-1 1.5-2 3.1-3.3 5.2-1.8-1.4-3.2-3.6-5-3.9-2.5-.5-6.1-.7-7.9.7-6.7 5.2-12.9 11.3-19.3 16.9-.6.5-2.1 1-2.5.6-.8-.8-1.7-2.1-1.8-3.2-.2-2.7.1-5.5-.1-8.2-.5-7.6-.6-7.6-8.3-7.3-1.8.1-3.5 0-7.1 0 2.4-4.6 4.4-8 6-11.7 1.4-3.2 3.2-6.5 3.2-9.9 0-6.1-.8-12.1-2-18.2-1.2-6.5-4.4-8.8-11.1-9.2-2.1-.1-4.4.1-6.4-.5-4.9-1.5-8.8-4-8.7-10.1.1-3.3-1.3-6.7-.8-9.9s1.7-6.7 3.7-9.3c.7-1 4.4.2 6.8.5 5.5.7 11 1.5 16.4 2.3-.3.6-.5 1.2-.7 1.8z"/>
        <g class="item-text">
          <path class="st2" d="M259.4 266h180v32.6h-180z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 266.4 290.574)" class="st3 st4 st5">
              Santo Domingo
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="galapagos">
        <g>
          <g>
            <path class="st1" d="M34.5 155c-.5-3.5-1.1-7.1-1.7-11.4-2.1.6-3.9 1.4-5.5 1.3-1.8-.2-4.2-1-5.1-2.4-.6-.8.2-3.9 1.4-4.8 4.4-3.5 9-6.7 14.1-9.4 1.2-.6 4.8 1 5.5 2.5 3.5 6.4 10 11.4 9 20.4-.4 3 4.4 7 7.5 9.9 5.2 4.8 10.8 9 8.1 15.5 3.8 5.4 7.6 9.4 9.8 14.2 1.7 3.6-6.7 14.2-10.8 15.4-4.6 1.4-9.4 2.9-13.9 4.6-6.9 2.9-23.1-3-25.6-9.6-.5-1.4.2-4.2 1.4-5.2 5.8-6 11.2-13 20.8-13 1.4 0 2.7-1.3 3.8-1.9-4.4-6-8.2-11.3-13-17.7-.5 2.4-.8 3.5-1 4.5-.6 4.8-3.1 7.7-8 8.1-6.8.5-11.2-2-13-7.1-2.6-7.7-1.9-8.9 5.8-10.7 3.6-1.1 6.7-2.2 10.4-3.2zM112.7 170.3c.4 4.6 7 5.5 5 12-2.5 8.1-11.2 13.1-19.1 9.3-8.8-4.4-10.2-6.3-7.5-13 1-2.4 3.6-4.8 6.1-5.5 4.9-1.5 10.1-1.8 15.5-2.8zM173.2 184c1.4.7 4.5 1.4 4.9 2.7.4 1.7-1.2 4.2-2.5 6-2.1 3-4.8 5.6-7 8.5-3.1 4-13.1 5.4-16.6 1.7-1-1.1-1.4-4.3-.7-4.9 5.5-4.6 11.2-8.8 16.9-13 1.2-.7 2.8-.6 5-1zM93.9 161.3c-4.3 6.3-17 6.9-22 1.1-3.6-4-2.4-8 .2-11.8 2.5-3.7 5.7-2.1 8.9-1.1 6.1 2.1 11.4 4.8 12.9 11.8zM108.7 224.8c-4.2 3.3-6.7 6.2-9.8 7.1-1.4.5-5.2-2.7-5.7-4.9-1-3.6 3.8-8.6 6.7-7.6 2.6.8 4.9 2.9 8.8 5.4zM95.9 125.8c-2.4-3.6-4.9-5.8-5-8.3-.1-1.4 4-4.8 5.4-4.4 2.9.8 5 3.7 7.5 5.6-2.3 2-4.4 4-7.9 7.1z"/>
          </g>
        </g>
        <g class="item-text">
          <path class="st2" d="M21 70.1h128.3v33H21z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 26.735 94.62)" class="st3 st4 st5">
              Galápagos
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="chimborazo">
        <path class="st1" d="M387.7 540.4c2.7-2.5 6-4.5 8.2-7.4 1.8-2.3 3.1-5.4 3.6-8.3 1.1-5.6 1.7-11.3 2-16.9.2-4.4.4-8.9-.4-13.2-1.2-7.1 1-10.1 8.1-10.8 2.5-.2 5.4-1.5 7-3.3 6.7-6.8 7.4-13.7 3-23.2-1.9-4.2 3.9-17.3 8.5-18.3 1.7-.4 4.3.1 5.4 1.2 10.1 10.4 21.3 8 32.5 2.9 3.5-1.5 5.7-1.3 8.6.4 2.7 1.5 5.6 2.5 8.2 3.6.4 3.5.5 6.7.8 9.9.6 4.6-.6 8.2-4.9 11.1-7.9 5.1-8.6 9.3-4 17.5 3 5.4.8 13-5.8 17.7-3.6 2.5-4 6-1.4 7.7 4.8 3.1 2.3 7.9 4 11.6.4.6-2 3.2-3.6 4-4.9 2.4-5.2 4.4-2.6 9.2 1.1 1.9 1.1 5.2.1 7.1-1.9 3.8-2.6 9-8.5 9.4.1 1.7-.4 4.5.5 5 9.9 6.1 9.4 15.5 8.3 25-.1 1.3-1.3 2.6-2 3.9-1.4-.8-3.2-1.4-4-2.7-5.8-8.7-11.9-17-23.3-18.7-1.1-.1-2.6-1.4-2.7-2.4-1.1-5.7-5-4.6-8-2.9-12.7 7.4-16.3 4.9-26.6-6-4.1-4.2-7.4-8.8-11-13.1z"/>
        <g class="item-text">
          <path class="st2" d="M406 497.8h138.9v29.8H406z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 411.3 522.15)" class="st3 st4 st5">
              Chimborazo
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="losrios">
        <path class="st1" d="M338.9 323.3c3.8-1 8-1.9 13.7-3.3-.2 4.5-1.1 8-.5 11.2.5 2.6 2.3 6.1 4.4 7.1 2.5 1.2 6.4 1.1 9-.1 3.9-1.9 7.5-4.9 10.6-8 3.2-3.1 5.7-7 8.5-10.5l1.4 1.4c.2.2.8.6.7.7-3.5 7.7-6.9 15.5-10.6 23-.7 1.5-2.6 2.6-4 3.8-.8.7-2.7 1.4-2.7 2 .2 7.3-7 10.4-8.8 16.4-.6 1.9-1.4 3.9-1.2 5.7 1.2 7.4-.5 14.1-3.9 20.7-1.2 2.4 1.2 6.7 2.1 10.6-3.3 3.8-7.6 8.3-11.6 13.2-.8 1.1-1.2 3.7-.5 4.6s3 1 4.6 1.1c3.1.2 6.2.2 10.2.5-4.6 5.1-8.2 8.5-11 12.3-.8 1.2-.1 4.5 1 5.8 3.8 4.2 8.2 7.7 12.7 11.9-2.4 1.8-5.5 3.9-8.5 6.2-2.9 2-3.2 4.4-.6 6.9 4.3 3.9 8.7 8 11.2 10.1 0 8.2 1.1 14.4-.2 19.8-2 8-.8 15 3.3 21.9-4.4 2.3-6.9 1.4-8.3-2.3-4.4-12-15.5-17.3-25.2-23.6-2.9-1.8-8.5-.8-12.3.5-8 2.6-14.4.5-17.3-7.5-2.3-6.5-4.2-12.7-11.7-16-2.6-1.1-4.9-5.7-5.4-8.9-2.4-14.8-1.7-28.9 8-41.6 3-3.9 4.3-8.9 7.1-12.9 2.7-3.7 6.3-6.8 10.1-9.5 4.5-3.3 8.7-7.7 15.4-7.1 1.2.1 3.3-1.4 3.6-2.5 1.3-5.8 2.3-11.7 3.2-17.6.4-2.3-.4-4.8.4-6.8 2.4-6.5 1.9-7.6-5-8.1-2.1-.1-4.3 0-6.8 0 .4-3.8-2-8.6 4.8-9.3.6-.1 1.4-.8 1.7-1.5 3.4-6.5 5.9-13.4 8.4-20.3z"/>
        <g class="item-text">
          <path class="st2" d="M253.4 422.1h101.4v28.5H253.4z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 259.4 445.344)" class="st3 st4 st5">
              Los Ríos
            </text>
          </g>
        </g>
      </g>
      <g class="item-a" id="bolivar">
        <path class="st1" d="M391.5 529.8c-4.2-7.6-4.5-7.7-14.1-4.6-1.4-3.7-2.1-7.9-4.4-11-4.3-5.7-2.6-11.6-1.7-17.5.5-2.6-.1-5.4 0-8 0-1.9-.1-4 .7-5.6 3.7-6.8 3.8-6.8-3.2-10.1 3.2-7.6-4.3-6.7-7.9-9 2.9-2.6 5.8-4.5 7.7-7.3 3.3-5.1 2.1-7.7-3.3-10-7.1-2.9-8-8.3-3-13.9 2.4-2.7 3.5-6.8 4.5-10.5.2-.7-2.1-2.1-3.3-3.2-1.9-1.8-5.6-3.9-5.5-5.5.4-3.2 3.2-4.9 7.3-4.2 1.8.4 4.3-.6 5.8-1.9 7.9-6.4 12.5-7 21.2-2.3 6.3 3.3 12.6 6.3 19.2-.1 2.9 4.6 1.9 8.5-.5 12-5.1 7.3-3.8 14.2 1.2 20.6 4.5 5.8 1 11.4 0 16.9-.6 3.6-.6 5.8 2.4 8.2 1.2 1 2 4.4 1.2 5.6-2 3.2-1.2 9.3-6.9 9.2-10.2-.4-16.6 8.1-13.8 19.6 1.1 4.3-.2 9.2-.6 13.8-.4 4.5-.7 8.9-1.3 13.3-.4 1.7-1.1 3.6-1.7 5.5z"/>
        <g class="item-text">
          <path class="st2" d="M348.3 454.5h83.1v29.4h-83.1z"/>
          <g>
            <text transform="matrix(1 0 0 1.1 353.186 478.166)" class="st3 st4 st5">
              Bolivar
            </text>
          </g>
        </g>
      </g>
    </svg>
  </v-flex>
<!-- MODAL -->
  <modal-app v-model="modal" :fullscreen="false" heightCerrar="80px" >
      <template slot="modalcontent">
        <div class="text-desc-b">
          <h2 class="titulo-modal">{{info.items[openitem].name}}</h2>
          <img :src="selected_image" alt="">
          <p>{{info.items[openitem].desc}}</p>
          <p class="fecha">{{info.items[openitem].fecha}}</p>
          <a class="linkpdf" :href="'https://static.adaptacioncc.com/documentos-pdf/'+info.items[openitem].urlpdf" target="_blanck">
            <div class="btn-vermas"> Ver más </div>
          </a>
        </div>
      </template>
  </modal-app>
</v-layout>
</div>

</template>
<script>
import resourcesLoader from "../js/mixins/resources-loader"
export default {
  mixins: [resourcesLoader],
  data() {
    return {
      itactive:[],
      selectItem:[],
      openitem:0,
      mostrarinfo:false,
      modal:false,
      unselect:'0',
      initselect:false,
      countitems:'',
      info: {},
      selected_image: '',
      tab: null,
      maxtab: false,
      tabactive: true,
      tabname:['en ejecución', 'finalizados'],
      tabnum:0,
      activos: null,
      inactivos: null
    }
  },
  created() {
    this.getJson('datosmapa', data => {
      this.info = data
      this.countitems = this.info.items.length  
      for (let index = 0; index < this.countitems; index++) {
        if(this.info.items[index].estado == "true") {
          this.activos ++
        }else{
          this.inactivos ++
        }
      }
      this.myEventHandler()
      this.scrollFix()
    })
    this.selectItem = Array(this.countitems).fill(false)
    this.itactive= Array(this.countitems).fill(false)
  },
  mounted() {
    window.addEventListener("resize", this.myEventHandler);
    this.myEventHandler()
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  watch:{
    tab(){
      this.cerrarinfo()
      this.modal = false
      this.itactive = Array(this.countitems).fill(false)
    }
  },
  filters:{
    ellipsis_box:function (value){
    var limite_text = value
    if (limite_text.length > 100){
        var limite = limite_text.substr(0, 100)+" ...";
        return limite
      }else{
        return value
      }
	  },
  },
  methods: {
    myEventHandler(){
      this.scrollFix()
      var wancho = window.innerWidth
      this.ancho = wancho
      console.log('this.ancho '+this.ancho)
      this.mostrarinfo = false
      this.modal = false
    },
    cerrarinfo(){
      this.mostrarinfo = false
    },
    scrollFix(){
      if( this.activos >= 7 || this.inactivos >= 7 ){
        this.maxtab = true
      }else{
        this.maxtab = false
      }
    },
    selectedAction(num){
      this.itactive = Array(this.countitems).fill(false)
      this.$set(this.itactive,num,true)
    },
    actionProyect(val){
      if(this.ancho >= 769){
        this.mostrarinfo = true
      } else{
        this.modal = true
      }
      this.selectedAction(val)
      // this.selected_image = '../../assets/presentacion/' + this.info.items[val].img + '.png';
      this.openitem = val
      this.selected_image = 'https://static.adaptacioncc.com/images/' + this.info.items[val].img + '.png';
      console.log(this.selected_image)
      if(this.initselect){
        for (let i = 0; i < this.info.items[this.unselect].slecteditem.length; i++) {
          var listSelect = document.getElementById(this.info.items[this.unselect].slecteditem[i])
              listSelect.classList.remove('selected-item')
        }
      }else{
        this.initselect = true
      }
      for (let i = 0; i < this.info.items[val].slecteditem.length; i++) {
        var listSelect = document.getElementById(this.info.items[val].slecteditem[i])
            listSelect.classList.add('selected-item')
      }
      this.unselect = val
    }
    
  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../sass/globals';

.general-back{
  background: white;
  width: 100%;
}
.tab-button{
  // background: #0d4c73;
  border-radius: 5px 5px 0px 0px;
  font-family: Raleway-Bold!important;
    box-shadow: rgba($color: #000000, $alpha: .6) 0px 2px 5px 1px inset;
}
.tab-inactive{
  background:#f6ebf5;
  box-shadow: none;
  color: #232323!important;
}
.tab-ejec{
  background: #ed6d1d!important;
  color:white!important;
}
.tab-fin{
  background: #078c96!important;
  color:white!important;
}
.item-active{
  z-index: 1;
  border: solid 3px #0d4c73; 
}
.bg-ejecucion{
  background: #ed6d1d!important;
  color: white!important;
}
.titulo-proyectos--estado{
  background: #078c96;
}

.cont-proyectos{
  background: white;
  box-shadow: 0 0 5px rgba($color: #000000, $alpha: .5) inset;
  border-radius: 10px;
  text-align: center;
  h2{
    color: white;
    margin: 0;
    padding: 4px 0px;
    font-size: 18px;
    font-weight: 500px;
    font-family: Raleway-Bold!important;
    // border-bottom: solid 1px #0D4C73;
    margin-bottom: 0px;
  }
  .cont-item-proyectos{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    .item-proyectos{
      width: 42%;
      padding: 0px;
      background: white;
      margin: 2px;
      cursor: pointer;
      transition: all 0.3s ease-in-out;
      box-shadow: 0 0 2px rgba($color: #000000, $alpha: .5);
      border-radius: 4px;
      img{
        width: 90%;
      }
      &:hover{
        transform: scale(1.05);
        box-shadow: 0 0 5px rgba($color: #000000, $alpha: .5);
        border-radius: 4px;
        z-index: 1;
      }
    }

  }

}
.fecha{
  margin: 4px 0px;
  padding: 0;
  font-size: 14px!important;
}

// ESTILOS EN EL MAPA
.st0{fill:#ffe6c1;}
.st1{fill: #0E748A;}
.st2{fill:#0d4c73;}
.st3{fill:#fff;}
.st4{font-family: Raleway-Bold!important;}
.st5{font-size:23px;}

.item-a{
  .item-text{
    opacity: 0;
    transition:all 0.3s ease-out;
    // transform: scale(1.2);
    transform-origin: center;
  }
}
.selected-item{
  .st1{
    fill:#ed6d1d; 
    transition: all 0.3s ease-in-out;
  }
  .item-text{
    opacity: 1;
  }
}
.mapa{
  position: relative;
  box-shadow: 0 0 10px 2px rgba($color: #000000, $alpha: .5);
  border-radius: 10px;
  overflow: hidden;
  background: #DBEFF1;
  line-height: 0px;
}

.cont-decription{
  // position: absolute;
  // border: solid red;
  width: 100%;
  background: rgba($color: #0d4c73, $alpha: 0.9);
  border-radius: 0px 0px 5px 5px;
  padding: 1px 0px 1px 0px;
  .iconcerrar{
    position: absolute;
    top: 3px;
    right: 3px;
  }
  img{
    width: 100px;
    padding: 10px;
    display: inline-block;
    vertical-align: middle;
    border-radius: 15px;
  }
  .text-desc{
    display: inline-block;
    vertical-align: middle;
    width:calc(100% - 127px);
    padding: 5px;
    color: white;
    h2,p{
      color:white;
    }
    h2{
      font-size: 16px!important;
      font-family: Raleway-Regular;
      font-weight: 100;
      line-height: 17.4px;
    }
    .btn-vermas{
      cursor: pointer;
      background: #e3a31c;
      color: #0d4c73;
      font-size: 13px;
      line-height: 15px;
      max-width: 65px;
      padding: 3px 2px;
      margin-top: 5px;
      text-align: center;
      transition: all 0.3s ease-in-out;
      .text-button{
        font-family: Raleway-Bold!important;
        font-weight: 100!important;
      }
      &:hover{
        background: white;
      }
    }
  }
}

@media screen and (max-width: 600px){
  .cont-decription{
    width: 100%;
  }
  .general-proyectos{
    margin-bottom: 5px;
  }

}

.text-desc-b{
    color: white;
    img{
      width: 200px;
      padding: 10px;
      display: inline-block;
      vertical-align: middle;
    }
      h2{
        font-size: 16px!important;
        line-height: 18px;
        font-family: Raleway-Light;
      }
      p{
        margin:5px 0px;
        font-family: Raleway-Regular;
        font-size: 14px!important;
      }
      .btn-vermas{
        background: #e3a31c;
        color: #0d4c73;
        font-family: Raleway-Bold;
        width: 80px;
        padding: 5px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        &:hover{
          background: #0d4c73;
          color: #e3a31c;
        }
      }
}
.titulo-modal{
  font-size: 20px!important;
  line-height: 22px;
  color:#0d4c73;
}
.linkpdf{
  text-decoration: none;
  display: block;
  width: 80px;
}
.general-taps-container{
  .tab-container{
    // min-height: 30vh;
    margin: 0 auto;
    text-align: center;
  }
}
.tab-scroll{
  overflow-x: hidden;
  max-height: 45vh!important;
}
@media (max-width: 769px) and (orientation:portrait) { 
  .general-proyectos{
    min-width: 65%;
    flex-grow: 0;
  }
  .mapa{
    min-width: 65%;
    flex-grow: 0;
  }
  .tab-scroll{
    overflow-x: hidden;
    max-height: 35vh!important;
  }
 }
 @media (max-height: 400px) and (orientation:landscape) { 
  .general-proyectos{
    max-width: 50%;
    flex-grow: 0;
  }
  .mapa{
    max-width: 50%;
    flex-grow: 0;
  }
  .tab-scroll{
    overflow-x: hidden;
    max-height: 35vh!important;
  }
 }
</style>
